import { datadogRum } from '@datadog/browser-rum-slim'

import { isDemo, isDevelopment, isProduction, isQA } from '~/src/utils/env'

import { beforeSend } from './utils'

const commonConfig = {
  version: import.meta.env.REACT_APP_SENTRY_RELEASE_TAG,
  sampleRate: 100,
  trackInteractions: true,
  site: 'datadoghq.com',
  beforeSend,
}

export function init() {
  if (isProduction) {
    datadogRum.init({
      ...commonConfig,
      clientToken: 'pub74665b2407a70a7351bf7130288ee8d2',
      applicationId: '284c5d0f-a070-4fc5-90a7-21a371e8cb55',
      service: 'web-prod',
      env: 'prd',
      allowedTracingOrigins: ['https://api.ramp.com'],
    })
  } else if (isQA) {
    datadogRum.init({
      ...commonConfig,
      clientToken: 'pubccafb03f1769714ddf7865e3c96f6a2b',
      applicationId: '313464de-0f5e-40b6-8821-75bdadd8258b',
      service: 'web-qa',
      env: 'qa',
      allowedTracingOrigins: ['https://qa-api.ramp.com'],
    })
  } else if (isDemo) {
    datadogRum.init({
      ...commonConfig,
      clientToken: 'pube0c57bf276f67e91f874e12f178639cf',
      applicationId: 'f55156c3-e670-41db-b22a-2ac84eba9d24',
      service: 'web-demo',
      env: 'demo',
      allowedTracingOrigins: ['https://demo-api.ramp.com'],
    })
  } else if (isDevelopment && import.meta.env.REACT_APP_ENABLE_DATADOG_RUM_DEV === 'true') {
    datadogRum.init({
      ...commonConfig,
      clientToken: 'pubd372f418cf7ff5b2a8b51d1a7fa0c12d',
      applicationId: '7d3f088f-f3eb-4cc0-ab4e-b43135a3fa84',
      service: 'web-dev',
      env: 'dev',
      allowedTracingOrigins: ['http://localhost:8000'],
    })
  }
}

export { addDatadogRumGlobalContext, removeDatadogRumGlobalContext } from './utils'
